import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { GraphQLService } from './graph-ql.service';
import { map } from 'rxjs/operators';
import { MailingAddress, ShopifyError } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ShopService extends GraphQLService {
  constructor() {
    super();
  }

  GetShopData(language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.add('shop', (shop: any) => {
        shop.add('name');
        shop.add('shipsToCountries');
      });
    });
    return from(this.client.send(query)).pipe(
      map((a: any) => {
        const errors = a['errors'] || [];
        if (errors.length) {
          throw errors as ShopifyError[];
        }
        return a['data'].shop;
      })
    ) as Observable<any>;
  }
}
